'use strict';

(function() {
  angular
    .module('specsguardApp')
    .directive('sgMatrixAreaItem', sgMatrixAreaItem);

  function sgMatrixAreaItem() {
    return {
      restrict: 'EA',
      templateUrl: 'app-legacy/project/areas/matrix/matrix-area-item/matrix-area-item.tmpl.html',
      controller: 'mAreaItemCtrl',
      controllerAs: '$mAreaItemCtrl',
      replace: true ,
      scope: {
        area: '=',
        module: '=',
        model: '=',
      }
    };
  }
})();
